<script lang="ts">
  import CalendarEventCard from "../../../../_shared/_modules/calendar-event-card"
  import type {
    BoardActions,
    BoardEvent,
    BoardMovePosition,
    BoardMovePreview,
  } from "../../../../../../../../_logic/calendar-types"

  type Position = { top?: number; height?: number }
  type BoardPropertyRef = NonNullable<BoardEvent["property"]>

  const {
    hardEvents = [],
    minEventHeight,
    formatAddress,
    employeeLabel = "",
    calendarSyncEnabled = false,
    canDirectlyEditEvents = false,
    isPastEvent,
    isPastInteractionLocked,
    canMoveEvent,
    canResizeEvent,
    activeEventId = null,
    ghostedEventId = null,
    hiddenEventId = null,
    activeMovePosition = null,
    movePreview = null,
    getEventPosition,
    actions,
    readOnly = false,
    showEventTooltips = true,
    showAppointmentTagTooltip = true,
    onDragStart = () => {},
    onResizeStart = () => {},
  }: {
    hardEvents: BoardEvent[]
    minEventHeight: number
    formatAddress: (property?: BoardPropertyRef) => string
    employeeLabel?: string
    calendarSyncEnabled?: boolean
    canDirectlyEditEvents?: boolean
    isPastEvent: (item: BoardEvent) => boolean
    isPastInteractionLocked: (item: BoardEvent) => boolean
    canMoveEvent: (item: BoardEvent) => boolean
    canResizeEvent: (item: BoardEvent) => boolean
    activeEventId?: string | null
    ghostedEventId?: string | null
    hiddenEventId?: string | null
    activeMovePosition?: BoardMovePosition | null
    movePreview?: BoardMovePreview | null
    getEventPosition: (item: BoardEvent) => Position
    actions: BoardActions
    readOnly?: boolean
    showEventTooltips?: boolean
    showAppointmentTagTooltip?: boolean
    onDragStart?: (item: BoardEvent, event: PointerEvent) => void
    onResizeStart?: (item: BoardEvent, direction: "start" | "end", event: PointerEvent) => void
  } = $props()

  const positionForEvent = (item: BoardEvent) => {
    if (activeMovePosition?.eventId === item.event.id) {
      return {
        top: activeMovePosition.top,
        height: activeMovePosition.height,
      }
    }

    return getEventPosition(item)
  }

  const isActiveEvent = (item: BoardEvent) => activeEventId === item.event.id
</script>

{#each hardEvents as item (item.event.id)}
  {#if hiddenEventId !== item.event.id}
    <CalendarEventCard
      {item}
      {minEventHeight}
      {formatAddress}
      {employeeLabel}
      {calendarSyncEnabled}
      allowInteractions={!readOnly &&
        canDirectlyEditEvents &&
        !isPastInteractionLocked(item) &&
        canMoveEvent(item)}
      allowResizeInteractions={!readOnly &&
        canDirectlyEditEvents &&
        !isPastInteractionLocked(item) &&
        canResizeEvent(item)}
      {readOnly}
      {showEventTooltips}
      {showAppointmentTagTooltip}
      overridePosition={positionForEvent(item)}
      isActive={isActiveEvent(item)}
      ghosted={ghostedEventId === item.event.id}
      isPast={isPastEvent(item)}
      onOpen={(event) => actions.openEvent(event)}
      onDragStart={(uiEvent, pointerEvent) => onDragStart(uiEvent, pointerEvent)}
      onResizeStart={(uiEvent, direction, pointerEvent) =>
        onResizeStart(uiEvent, direction, pointerEvent)}
    />
  {/if}
{/each}

{#if movePreview}
  <CalendarEventCard
    item={movePreview.item}
    {minEventHeight}
    {formatAddress}
    {employeeLabel}
    {calendarSyncEnabled}
    readOnly={true}
    showEventTooltips={false}
    overridePosition={{ top: movePreview.top, height: movePreview.height }}
    useRouteInsets={false}
    isActive={true}
    preview={true}
    isPast={false}
    onOpen={() => undefined}
  />
{/if}
